// Expand the range of the chart before and after the anomaly occurred for more context..
export const HOURS_BEFORE_START = 12;
export const HOURS_AFTER_END = 2;
